export const GET_ROOM_MESSAGES_REQUEST = 'GET_ROOM_MESSAGES_REQUEST';
export const GET_ROOM_MESSAGES_SUCCESS = 'GET_ROOM_MESSAGES_SUCCESS';
export const GET_ROOM_MESSAGES_FAIL = 'GET_ROOM_MESSAGES_FAIL';
export const GET_ROOM_MESSAGES_RESET = 'GET_ROOM_MESSAGES_RESET';

export const CREATE_MESSAGE_REQUEST = 'CREATE_MESSAGE_REQUEST';
export const CREATE_MESSAGE_SUCCESS = 'CREATE_MESSAGE_SUCCESS';
export const CREATE_MESSAGE_FAIL = 'CREATE_MESSAGE_FAIL';
export const CREATE_MESSAGE_RESET = 'CREATE_MESSAGE_RESET';

export const UPDATE_DISPLAYED_MESSAGES = 'UPDATE_DISPLAYED_MESSAGES';
